export const importLogin = () => {
    return new Promise((resolve,reject)=>{
        import(/* webpackChunkName: "pc-login" */'pc-login').then((res)=>{
            const login = res.default
            const loginIndex = login.loginIndex
            loginIndex?.$el.on('login:success',() => {
				// 登录成功分发
                window.EVENT_BUS.$emit('loginSuccess')
            })
            resolve(login)
        })
    })
}
